import {testIdProps} from '@github-ui/test-id-props'
import {PulseIcon} from '@primer/octicons-react'
import {RelativeTime} from '@primer/react'
import {memo, useEffect} from 'react'

import {useMarkdownPreview} from '../../hooks/use-markdown-preview'
import {useRecapsQuery} from '../../queries/use-recaps-query'
import {SanitizedMarkdownViewer} from '../common/sanitized-markdown-viewer'
import contentStyles from './content.module.css'
import {SidePanelToolbar} from './header'
import styles from './recap-content.module.css'

export const RecapContent = memo(function RecapContent() {
  const {data, isLoading, error} = useRecapsQuery()
  const {html: reportHtml, loadPreview} = useMarkdownPreview()

  const hasValidData = data && ((data.insights && data.insights.length > 0) || data.report)

  useEffect(() => {
    if (data?.report?.content) {
      const unescapedContent = data.report.content.replace(/\\n/g, '\n')
      loadPreview(unescapedContent)
    }
  }, [data?.report?.content, loadPreview])

  return (
    <div className={contentStyles.infoPanelContainer} {...testIdProps('side-panel-recap-content')}>
      <div className={contentStyles.infoPanelContent}>
        <div className={contentStyles.infoPanelHeader}>
          <SidePanelToolbar showCloseButton />
          <div className={contentStyles.headerSpacer} />
          <h2>Recap</h2>
        </div>

        {isLoading && <div>Loading insights...</div>}

        {error && <div>Failed to load insights</div>}

        {hasValidData && (
          <div className={styles.recapsContent}>
            {data.created_at && (
              <h2 className={styles.insightTitle}>
                Week of {new Date(data.created_at).toLocaleDateString('en-US', {month: 'short', day: 'numeric'})}
                <span className={styles.recapDate}>
                  Generated <RelativeTime datetime={data.created_at} />
                </span>
              </h2>
            )}

            {data.insights && data.insights.length > 0 && (
              <div className={styles.insightCard}>
                <div className={styles.insightHeader}>
                  <h3 className={styles.insightTitle}>Insights</h3>
                </div>
                <ul className={styles.insightList}>
                  {data.insights.map(insight => (
                    <li key={insight.id} className={styles.insightItem}>
                      <PulseIcon size={16} aria-hidden="true" />
                      <span className={styles.insightText}>{insight.content}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {data.report && reportHtml && (
              <div className={styles.insightCard}>
                <div className={styles.reportContent}>
                  <SanitizedMarkdownViewer unverifiedHTML={reportHtml} openLinksInNewTab />
                </div>
              </div>
            )}
          </div>
        )}

        {!isLoading && !error && !hasValidData && <div>No recap data available</div>}
      </div>
    </div>
  )
})

try{ RecapContent.displayName ||= 'RecapContent' } catch {}